import { Helmet } from 'react-helmet-async';
import React from 'react';
import requireAuth from '../../../lib/requireAuth.jsx';
import withRouterParams from '../../../lib/withRouterParams.jsx';

import ChangeStrategyContainer from '../../../containers/projects/ChangeStrategyContainer.jsx';

const ShowChangeStrategy = ({ projectId, slug }) => {
  return (
    <>
      <Helmet>
        <title>Change Strategy | ChangeSync</title>
      </Helmet>
      <ChangeStrategyContainer projectId={projectId} slug={slug} />
    </>
  );
};

ShowChangeStrategy.getInitialProps = ({ query }) => ({
  projectId: Number(query.projectId),
  slug: query.slug,
});

export default requireAuth(withRouterParams(ShowChangeStrategy));
